module.exports = __webpack_public_path__ + "images/preview@3x.png?b65a810b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview@3x.png
// module id = 682
// module chunks = 7